import Loader from './loader';

export default class Newsletter {
    constructor($wrapper) {
        this.$email = $wrapper.querySelector('input[type="email"]');
        this.$emailError = $wrapper.querySelector('[data-email-error]');
        this.$noEmailError = $wrapper.querySelector('[data-no-email-error]');
        this.$fatalError = $wrapper.querySelector('[data-fatal-error]');
        this.$interest = $wrapper.querySelector('input[name="interest"]');
        this.$source = $wrapper.querySelector('input[name="source"]');
        this.$campaign = $wrapper.querySelector('input[name="campaign"]');
        this.$submit = $wrapper.querySelector('[data-submit]');
        this.loader = (new Loader($wrapper.querySelector('[data-newsletter-loader]')));

        this.submitNewsletter = this.submitNewsletter.bind(this);

        this.$submit.addEventListener('click', this.submitNewsletter);
    }

    async submitNewsletter(e) {
        e.preventDefault();
        this.$emailError.classList.add('d-none');
        this.$noEmailError.classList.add('d-none');

        // only if email
        if (! this.$email.value) {
            this.$noEmailError.classList.remove('d-none');
            return;
        }

        // validate email
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.$email.value)) {
            this.loader.loading(false);

            this.$emailError.classList.remove('d-none');
            this.$email.focus();
            return;
        }

        // if not loading
        if (this.$submit.classList.contains('loading')) {
            return;
        }
        this.loader.loading(true);
        this.$submit.classList.add('loading');

        const result = await this.sendNewsletterSubscription();
        if(result) {
            this.loader.loading(false);
            location.href = result.url;
        }
    }

    async sendNewsletterSubscription() {
        this.$fatalError.classList.add('d-none');

        const body = JSON.stringify({
            email: this.$email.value,
            interest: (this.$interest ? this.$interest.value : null),
            source: (this.$source ? this.$source.value : null),
            campaign: (this.$campaign ? this.$campaign.value : null)
        });

        try {
            const request = await fetch(
                placeholders.baseUri
                        ? placeholders.baseUri + '/ajax/type/61/submitNewsletter'
                        : 'ajax/type/61/submitNewsletter',
                {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
            this.loader.loading(false);
            this.$submit.classList.remove('loading');
            this.$fatalError.classList.remove('d-none');
        }
    }
}